import { JobPrototype } from '../types'
import { ActionType, UPDATE_JOB, CREATE_JOB } from '../actions/job'

export interface JobPrototypeState extends JobPrototype { }

const initialState: JobPrototypeState | null = null

export function jobReducer(state: JobPrototypeState | null = initialState, action: ActionType) {
    switch (action.type) {
        case CREATE_JOB: {
            return action.payload.job as JobPrototypeState
        }
        case UPDATE_JOB: {
            return {
                ...state,
                ...action.payload.job
            }
        }
        default: {
            return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/job.ts